import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import "./styles.css";
import { FormikProps } from "formik";
import InputTextfield from "../../../../../../shared/components/textField";
import { LoadingButton } from "@mui/lab";
import Loader from "../../../../../../shared/components/loader/linearProgress";

interface PropertyEditDialogProps {
  open: boolean;
  onClose: () => void;
  propertyForm: FormikProps<any>;
  propertySettingsFields: {
    id: string;
    name: string;
    label: string;
    type: string;
    placeholder: string;
    required: boolean;
  }[];
  submitDisabled: boolean;
  loading: boolean;
  submitLoading?: boolean;
}

const PropertyEditDialog: React.FC<PropertyEditDialogProps> = ({
  open,
  onClose,
  propertyForm,
  propertySettingsFields,
  submitDisabled,
  loading,
  submitLoading = false,
}) => {
  const isAddressExists =
    propertyForm?.values?.propertySetting?.addressLane1 ||
    propertyForm?.values?.propertySetting?.addressLane2 ||
    propertyForm?.values?.propertySetting?.postalCode ||
    propertyForm?.values?.propertySetting?.city ||
    propertyForm?.values?.propertySetting?.state ||
    propertyForm?.values?.propertySetting?.country;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="edit-property-dialog"
    >
      <DialogTitle>{`${
        loading
          ? ""
          : isAddressExists
          ? "Edit Property Address"
          : "Add Property Address"
      }`}</DialogTitle>
      <DialogContent>
        {loading ? (
          <Loader />
        ) : (
          <form onSubmit={propertyForm?.handleSubmit}>
            <Grid container spacing={2}>
              {/* Property Title - read only */}
              <Grid item xs={12}>
                <Typography>
                  Property Name:{" "}
                  <b>{propertyForm?.values?.propertySetting?.title}</b>
                </Typography>
              </Grid>

              {/* Editable fields */}
              {propertySettingsFields
                ?.filter((field) => field.name !== "title") // exclude Property Name
                .map((field) => (
                  <Grid item xs={12} sm={6} key={field.id}>
                    <InputTextfield
                      fieldProps={{
                        id: field.id,
                        name: `propertySetting.${field.name}`,
                        type: field.type,
                        label: field.label,
                        placeholder: field.placeholder,
                        required: field.required,
                      }}
                      form={propertyForm}
                      value={
                        propertyForm?.values?.propertySetting[
                          field.name as keyof typeof propertyForm.values.propertySetting
                        ]
                      }
                      error={
                        (propertyForm?.errors as any)?.propertySetting?.[
                          field?.name
                        ] &&
                        (propertyForm?.touched as any)?.propertySetting?.[
                          field?.name
                        ]
                          ? (propertyForm?.errors as any)?.propertySetting?.[
                              field?.name
                            ]
                          : undefined
                      }
                      onChange={(val: any) => {
                        propertyForm?.setFieldValue(
                          `propertySetting.${field?.name}`,
                          val
                        );
                      }}
                    />
                  </Grid>
                ))}
            </Grid>

            <DialogActions>
              <Button onClick={onClose}>Cancel</Button>
              <LoadingButton
                type="submit"
                variant="contained"
                color="primary"
                disabled={submitDisabled}
                loading={submitLoading}
              >
                Save Changes
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PropertyEditDialog;
